const PROMO_CODE_MODEL_CLASS_NAME = 'PromoCode'

const PROMO_CODE_MODEL_KEY = {
  EXPIRE_AT: 'expireAt',
  NAME: 'name',
  VALUE: 'value',
  PRODUCTS: 'products'
}

const PROMO_CODE_MODEL_KEY_POINTER = PROMO_CODE_MODEL_KEY.NAME
const PROMO_CODE_MODEL_VALIDATOR = {
  [PROMO_CODE_MODEL_KEY.NAME]: [
    0,
    20
  ]
}

const PROMO_CODE_MODEL_PLACEHOLDER = {
  [PROMO_CODE_MODEL_KEY.NAME]: 'Promo code name',
  [PROMO_CODE_MODEL_KEY.VALUE]: 'Code value in percentage',
  [PROMO_CODE_MODEL_KEY.EXPIRE_AT]: 'Number of days the PromoCode will remain active'
}

/**
 * A mapping of property key to className.
 * @type {Object}
 */
const PROMO_CODE_MODEL_ASSOCIATION = {
  [PROMO_CODE_MODEL_KEY.PRODUCTS]: 'Product'
}

export {
  PROMO_CODE_MODEL_CLASS_NAME,
  PROMO_CODE_MODEL_KEY,
  PROMO_CODE_MODEL_KEY_POINTER,
  PROMO_CODE_MODEL_PLACEHOLDER,
  PROMO_CODE_MODEL_VALIDATOR,
  PROMO_CODE_MODEL_ASSOCIATION
}
